import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Input, Button, Dropdown, DropdownToggle, DropdownMenu, FormGroup, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
// import { FaCalendarAlt } from 'react-icons/fa';
import { connect } from 'react-redux';
import UpdateProjectDetailsService from '../../../../../Service/DashboardServices/ProjectsDashboard/UpdateProjectDetailsService';
import { FaCalendarAlt } from 'react-icons/fa';
import FetchCMProductDataService from '../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService';
import CustomModal from '../../../../Components/Modals/CustomModal';
import NewProjectProductList from '../Scenes/SidebarComponents/NewProjectProductList';
import NewTaskIcon from '../../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';
import ReactQuill from 'react-quill';
import { Editor, SetInnerHtmlWithClassReplacement } from "../../../../../Utils/Constants";

function UpdateProjectDetails(props) {

    const normalizeDesignerIds = (ids) => {
        if (ids === null || ids === undefined || ids === '') return [];
        if (Array.isArray(ids)) return ids.map(Number).filter(function (id) { return !isNaN(id); });
        const single = Number(ids);
        return isNaN(single) ? [] : [single];
    };

    const [loading, setLoading] = useState(false);
    const [addProductsPopup, setAddProductsPopup] = useState(false)
    const [productList, setProductList] = useState()
    const [asinList, setAsinList] = useState(null);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [duplicateProjects, setDuplicateProjects] = useState([]);
    const [text, setText] = useState('');
    const [designerDropdownOpen, setDesignerDropdownOpen] = useState(false);

  // Store original data for comparison
    const [originalData, setOriginalData] = useState({});
    const [newFormData, setNewFormData] = useState({
        id: props.projectDetailsForEdit.projectId,
        ownerId: props.projectDetailsForEdit.ownerId,
        graphicDesignerId: normalizeDesignerIds(props.projectDetailsForEdit.graphicDesignerId),
        projectName: props.projectDetailsForEdit.projectName || props.projectDetailsForEdit.name,
        projectOwner: props.projectDetailsForEdit.owner,
        graphicDesigner: props.projectDetailsForEdit.graphicDesigner,
        dueDate: props.projectDetailsForEdit.dueDate,
        startDate: props.projectDetailsForEdit.startDate,
        brandId: props.projectDetailsForEdit.brandId,
        action: 'false',
        asin: props.projectDetailsForEdit.asin,
        asinList: Array.isArray(props.projectDetailsForEdit.asin) ? props.projectDetailsForEdit.asin : props.projectDetailsForEdit.asin ? [props.projectDetailsForEdit.asin] : []
    });
    // Helper to normalize asin prop into array of trimmed ASINs
    const getAsinArray = (asin) => {
        if (!asin) return [];
        if (Array.isArray(asin)) return asin;
        return asin
            .toString()
            .split(',')
            .map(s => s.trim())
            .filter(Boolean);
    };

    const getProductDisplayName = (product) => {
        if (!product) return '';
        return (product.productTitle || product.name || '').trim();
    };

    const truncateString = (str, maxLength) => {
        if (!str) return '';
        if (str.length <= maxLength) return str.trim();
        return str.slice(0, maxLength).trim();
    };

    const resolveParentAsin = (product) => {
        if (!product) return '';
        if (product.isParentProduct) return product.asin;
        return product.parentProduct || product.asin || '';
    };

    const resolveProductByAsin = (asin, products, fallbackProducts) => {
        return (products || []).find((p) => p.asin === asin)
            || (fallbackProducts || []).find((p) => p.asin === asin)
            || (fallbackProducts || []).find((p) => p.parentProduct === asin)
            || null;
    };

    // Naming convention (same as Create):
    // 1 ASIN: Store(20) - Workflow(no Creation) - ASIN - Product(15)
    // Multiple ASINs same parent: Store(20) - Workflow - Parent ASIN - Parent Product(15)
    // Multiple ASINs different parents: Store(20) - Workflow - ParentASINs(comma) - First Parent Product(15)
    const buildAutoProjectName = (asins, products) => {
        const storeName = truncateString(
            (props.projectDetailsForEdit && props.projectDetailsForEdit.storeName) || '',
            20
        );
        if (!storeName) return '';

        const workflowNames = (
            (props.projectDetailsForEdit && props.projectDetailsForEdit.workflow) || []
        )
            .map((name) => (name || '').replace(/\bCreation\b/gi, '').replace(/\s+/g, ' ').trim())
            .filter(Boolean)
            .join(', ');

        const workflowId = Number(
            props.projectDetailsForEdit && props.projectDetailsForEdit.workflowsId
        );
        if ([7, 8, 9].indexOf(workflowId) !== -1) {
            return workflowNames ? (storeName + ' - ' + workflowNames) : storeName;
        }

        const asinArr = (Array.isArray(asins) ? asins : []).filter(Boolean);
        let finalAsinStr = '';
        let finalProductName = '';

        if (asinArr.length > 0) {
            const selectedProducts = asinArr
                .map((asin) => (products || []).find((p) => p.asin === asin))
                .filter(Boolean);

            if (asinArr.length === 1) {
                finalAsinStr = asinArr[0];
                finalProductName = truncateString(
                    getProductDisplayName(selectedProducts[0]),
                    15
                );
            } else {
                const parentAsins = selectedProducts
                    .map(resolveParentAsin)
                    .filter(Boolean);
                const uniqueParents = Array.from(new Set(parentAsins));

                if (uniqueParents.length === 1) {
                    finalAsinStr = uniqueParents[0];
                    const parentProd = resolveProductByAsin(
                        uniqueParents[0],
                        products,
                        selectedProducts
                    );
                    finalProductName = truncateString(
                        getProductDisplayName(parentProd),
                        15
                    );
                } else if (uniqueParents.length > 1) {
                    finalAsinStr = uniqueParents.join(',');
                    const firstParentProd = resolveProductByAsin(
                        uniqueParents[0],
                        products,
                        selectedProducts
                    );
                    finalProductName = truncateString(
                        getProductDisplayName(firstParentProd),
                        15
                    );
                } else {
                    finalAsinStr = asinArr.join(',');
                    finalProductName = truncateString(
                        getProductDisplayName(selectedProducts[0]),
                        15
                    );
                }
            }
        }

        const parts = [storeName];
        if (workflowNames) parts.push(workflowNames);
        if (finalAsinStr) parts.push(finalAsinStr);
        if (finalProductName) parts.push(finalProductName);
        return parts.join(' - ');
    };

    // Helper function to normalize dates for comparison
    const normalizeDateForComparison = (date) => {
        if (!date) return null;
        if (date instanceof Date) {
            return date.toISOString().split('T')[0];
        }
        return new Date(date).toISOString().split('T')[0];
    };
    useEffect(() => {
        if (props.projectDetailsForEdit) {
            // Handle note/description
            const initialNote = props.projectDetailsForEdit.note || props.projectDetailsForEdit.description || "";
            setText(initialNote);
    
            // Handle asin list
            const existingAsins = getAsinArray(props.projectDetailsForEdit.asin);
            const normalizedAsins = Array.from(new Set(existingAsins.map(String)));
            setAsinList(normalizedAsins);

            const designerIds = normalizeDesignerIds(props.projectDetailsForEdit.graphicDesignerId);
            setNewFormData(prev => ({
                ...prev,
                ownerId: props.projectDetailsForEdit.ownerId,
                graphicDesignerId: designerIds,
                projectName: props.projectDetailsForEdit.projectName || props.projectDetailsForEdit.name,
                graphicDesigner: props.projectDetailsForEdit.graphicDesigner,
                dueDate: props.projectDetailsForEdit.dueDate,
                startDate: props.projectDetailsForEdit.startDate,
                brandId: props.projectDetailsForEdit.brandId,
            }));
    
            // Set original data for comparison
            setOriginalData({
                ownerId: props.projectDetailsForEdit.ownerId,
                graphicDesignerId: designerIds,
                projectName: props.projectDetailsForEdit.projectName || props.projectDetailsForEdit.name,
                brandId: props.projectDetailsForEdit.brandId,
                dueDate: props.projectDetailsForEdit.dueDate,
                startDate: props.projectDetailsForEdit.startDate,
                asin: normalizedAsins
            });
        }
    }, [props.projectDetailsForEdit]);

    useEffect(() => {
        setNewFormData(prev => ({
            ...prev,
            asin: Array.isArray(asinList) ? asinList : [asinList],
            asinList: Array.isArray(asinList) ? asinList : [asinList]
        }));
    }, [asinList]);

    // Keep Edit project name in sync with naming convention when ASINs change
    useEffect(() => {
        if (!Array.isArray(asinList) || !productList) return;
        const autoName = buildAutoProjectName(asinList, productList);
        if (!autoName) return;
        setNewFormData((prev) => ({
            ...prev,
            projectName: autoName,
        }));
    }, [asinList, productList]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewFormData({
            ...newFormData,
            [name]: value,
        });
    };

    const handleGraphicDesignerCheckboxChange = (id) => {
        const designerId = Number(id);
        const current = normalizeDesignerIds(newFormData.graphicDesignerId);
        let updated;
        if (current.includes(designerId)) {
            updated = current.filter(item => item !== designerId);
        } else {
            updated = current.concat([designerId]);
        }
        setNewFormData({
            ...newFormData,
            graphicDesignerId: updated,
        });
    };

    const baseDesignerIds = (props.graphicDesignerList || []).map(d => Number(d.id));
    const projectDesignerList = (props.graphicDesignerList || []).concat(
        ((props.projectDetailsForEdit && props.projectDetailsForEdit.assignedGraphicDesigners) || [])
            .filter(d => !baseDesignerIds.includes(Number(d.id)))
    );

    const getSelectedDesignerNames = () => {
        const selected = normalizeDesignerIds(newFormData.graphicDesignerId);
        if (!selected.length) return 'Select Graphic Designer';
        return projectDesignerList
            .filter(d => selected.includes(Number(d.id)))
            .map(d => (d.name || '').replace(/\s*Working\(\d+\)\s*$/, ''))
            .join(', ');
    };

    const hasFormChanged = () => {
        // Wait for original data to be set
        if (!originalData.ownerId && originalData.ownerId !== '' && originalData.ownerId !== null) {
            return false;
        }
        // Compare basic fields - handle null/undefined values
        if ((newFormData.ownerId || '') !== (originalData.ownerId || '')) return true;
        const currentDesigners = [...normalizeDesignerIds(newFormData.graphicDesignerId)].sort();
        const originalDesigners = [...normalizeDesignerIds(originalData.graphicDesignerId)].sort();
        if (JSON.stringify(currentDesigners) !== JSON.stringify(originalDesigners)) return true;
        if ((newFormData.projectName || '') !== (originalData.projectName || '')) return true;
        if ((newFormData.brandId || '') !== (originalData.brandId || '')) return true;
        if ((text || '').trim() !== (props.projectDetailsForEdit.description || '').trim()) return true;
        // Compare dates
        const newStartDate = normalizeDateForComparison(newFormData.startDate);
        const originalStartDate = normalizeDateForComparison(originalData.startDate);
        if (newStartDate !== originalStartDate) return true;

        const newDueDate = normalizeDateForComparison(newFormData.dueDate);
        const originalDueDate = normalizeDateForComparison(originalData.dueDate);
        if (newDueDate !== originalDueDate) return true;

        // Compare ASINs
        const currentAsin = Array.isArray(asinList) ? [...asinList].sort() : [];
        const originalAsin = Array.isArray(originalData.asin) ? [...originalData.asin].sort() : [];
        
        if (currentAsin.length !== originalAsin.length) return true;
        for (let i = 0; i < currentAsin.length; i++) {
            if (String(currentAsin[i]).trim() !== String(originalAsin[i]).trim()) return true;
        }

        return false;
    };

    const handleSelectProduct = () => {
        let data = {
            asinList:'',
            integerID: props.projectDetailsForEdit.integerId,
            fetchAll: true,
            projectId:0,
        }
        FetchCMProductDataService(props.token, data).then((res) => {
            if (res) {
                console.log(res)
                setProductList(res.productsList)
                setAddProductsPopup(true)
            }
        })
    }
    const checkForDuplicateProjects = () => {
        const duplicateProjects = props.projectDetailsList.filter(project =>
            project.accountId === parseInt(props.projectDetailsForEdit.accountId) &&
            project.integerId === parseInt(props.projectDetailsForEdit.integerId) &&
            project.brandId === parseInt(newFormData.brandId) &&
            project.workflowsId === parseInt(props.projectDetailsForEdit.workflowsId) &&
            project.projectId !== props.projectDetailsForEdit.projectId // Exclude current project
        );

        if (duplicateProjects.length > 0) {
            // Store all duplicate project details
            setDuplicateProjects(duplicateProjects);
            setShowConfirmationPopup(true);
            return true; // Has duplicates
        }
        return false; // No duplicates
    };
    const handleBrandChange = (e) => {
        const brandId = e.target.value;
        const selectedText =
    e.target.options &&
    e.target.options[e.target.selectedIndex] &&
    e.target.options[e.target.selectedIndex].text;

    
        const brandName =
            brandId && selectedText !== "Select Brand"
                ? selectedText
                : null;
    
        setNewFormData(prev => ({
            ...prev,
            brandId,
            brandName, 
        }));
    };
    
    const saveProject = () => {
        if (props.projectDetailsForEdit.startDate instanceof Date) {
            props.projectDetailsForEdit.startDate = props.projectDetailsForEdit.startDate.toISOString().split('T')[0];
        }
        const updatedData = {
            ...newFormData,
            description: text,
            projectId:props.projectDetailsForEdit.projectId,  
          };
        setLoading(true);
        UpdateProjectDetailsService(props.token, updatedData).then((res) => {
            setLoading(false);
            if (res) {
                console.log(res)
                props.setOpenProjectEditPopup(false)
                props.setProjectDetailsList(res.ProjectDetailsList)
            }
        });
    };
    const hasBrandChanged = () => {
        return (newFormData.brandId || '') !== (originalData.brandId || '');
    };
    const handleSubmitEditInfo = () => {
        if (!hasFormChanged()) return;
        // Check for duplicates first
        if (hasBrandChanged() && checkForDuplicateProjects()) {
            return; // Stop here if duplicates found, popup will show
        }
        // If no duplicates, proceed with saving
        saveProject();
    };
    const handleConfirmDuplicate = () => {
        setShowConfirmationPopup(false);
        saveProject(); 
    };

    const handleCancelDuplicate = () => {
        setShowConfirmationPopup(false);
        // User canceled, don't save
    };
    return (
        <>
            <Col className='mb-4 px-3'>
                <Row className='mt-3'>
                    <Col md={2} className="d-flex align-items-center">
                        <label className="mb-0">
                            <h6 className="mb-0">
                                <b>Name : <span style={{ color: 'red' }}>*</span></b>
                            </h6>
                        </label>
                    </Col>
                    <Col md={10}>
                        <Input
                            type="text"
                            name="projectName"
                            value={newFormData.projectName || ''}
                            onChange={handleChange}
                            placeholder="Auto-generated project name"
                            className="create-new-project-width"
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={6} className='mt-3'>
                        <label><h6><b>Store Name : <span style={{ color: 'red' }}>*</span></b></h6></label>
                        <Input
                            type='text'
                            className='create-new-project-width'
                            value={props.projectDetailsForEdit.storeName || ''}
                            disabled
                        />
                    </Col>

                    <Col md={6} className='mt-3'>
                        <label><h6><b>Brand : </b></h6></label>
                        <select
                            name="brandId"
                            className="form-control create-new-project-width"
                            value={newFormData.brandId || ''}
                            onChange={handleBrandChange}   
                        >
                            <option value="">Select Brand</option>
                            {props.brandList &&
                                props.brandList
                                    .filter(brand =>
                                        !props.projectDetailsForEdit.integerId ||
                                        brand.integerId === parseInt(props.projectDetailsForEdit.integerId)
                                    )
                                    .map((brand) => (
                                        <option key={brand.id} value={brand.id}>
                                            {brand.brandName}
                                        </option>
                                    ))}
                        </select>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <div className='mt-3'>
                            <label><h6><b>WorkFlows : <span style={{ color: 'red' }}>*</span></b></h6></label>
                            <div  title={
        props.projectDetailsForEdit.workflow &&
        props.projectDetailsForEdit.workflow
            .map(item => item.replace(/\s*Creation\s*/gi, '').trim())
            .join(', ')
    }
    className="mb-0"
    style={{
        maxHeight: '60px',
        overflowY: 'auto',
    }}
>
    {props.projectDetailsForEdit.workflow &&
        props.projectDetailsForEdit.workflow.map((item, index) => (
            <span key={index}>
                {item.replace(/\s*Creation\s*/gi, '').trim()}
                <br />
            </span>
        ))
    }
    </div>
                        </div>

                        <div className='mt-3'>
                            <label><h6><b>Project Owner : <span style={{ color: 'red' }}>*</span></b></h6></label>
                            <select
                                name="ownerId"
                                className="form-control create-new-project-width"
                                value={newFormData.ownerId || ''}
                                onChange={handleChange}
                            >
                                <option disabled value="">Select Project Owner</option>
                                {props.ownerList && props.ownerList.map((owner) => (
                                    <option key={owner.employeeId} value={owner.employeeId}>
                                        {owner.employeeName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="mt-3">
                            <div className="d-flex align-items-center mb-2">
                                <h6 className="mb-0 mr-3"><b>ASIN List :</b></h6>
                                {[7, 8, 9].indexOf(Number(props.projectDetailsForEdit.workflowsId)) === -1 && (
                                    <Button
                                        className="btn-background-color d-flex align-items-center justify-content-center p-1"
                                        onClick={() => { handleSelectProduct() }}
                                        disabled={!props.projectDetailsForEdit.storeName}
                                        style={{ minWidth: '40px' }}
                                    >
                                        <img src={NewTaskIcon} style={{ height: '18px' }} alt="add" />
                                    </Button>
                                )}
                                {[7, 8, 9].indexOf(Number(props.projectDetailsForEdit.workflowsId)) !== -1 && (
                                    <h6 className="mb-0 ml-2">Not Required</h6>
                                )}
                            </div>

                            {[7, 8, 9].indexOf(Number(props.projectDetailsForEdit.workflowsId)) === -1 && (
                                <div
                                    style={{
                                        maxHeight: '120px', 
                                        overflowY: 'auto',
                                        display: 'grid',    
                                        gridTemplateColumns: '1fr 1fr 1fr', 
                                        columnGap: '10px',  
                                        paddingRight: '5px' 
                                    }}
                                >
                                    {Array.isArray(asinList) ? (
                                        asinList.map((asin, index) => {
                                            const product = productList && productList.find(p => p.asin === asin);
                                            return (
                                                <div
                                                    key={index}
                                                    title={(product && product.productTitle) || (product && product.name) || ''}
                                                    className="mb-1"
                                                >
                                                    {asin}{index < asinList.length - 1 ? ',' : ''}
                                                </div>
                                            );
                                        })
                                    ) : (
                                        getAsinArray(props.projectDetailsForEdit.asin).map((a, i, arr) => (
                                            <div key={i} className="mb-1">
                                                {a}{i < arr.length - 1 ? ',' : ''}
                                            </div>
                                        ))
                                    )}
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col md={6} className='mt-3'>
                        <label><h6><b>Graphic Designer : </b></h6></label>
                        <Dropdown isOpen={designerDropdownOpen} toggle={() => setDesignerDropdownOpen(!designerDropdownOpen)} className="create-new-project-width">
                            <DropdownToggle
                                caret
                                className="form-control d-flex justify-content-between align-items-center"
                                style={{ backgroundColor: 'white', color: '#495057', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}
                            >
                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%' }}>
                                    {getSelectedDesignerNames()}
                                </span>
                            </DropdownToggle>
                            <DropdownMenu
                                style={{ width: '100%', maxHeight: '200px', overflowY: 'auto', padding: '10px' }}
                            >
                                {projectDesignerList.map((designer) => (
                                    <FormGroup check key={designer.id} className="m-2">
                                        <Label check style={{ cursor: 'pointer', width: '100%' }}>
                                            <Input
                                                type="checkbox"
                                                checked={normalizeDesignerIds(newFormData.graphicDesignerId).includes(Number(designer.id))}
                                                onChange={() => handleGraphicDesignerCheckboxChange(designer.id)}
                                            />
                                            {' '}{designer.name}
                                        </Label>
                                    </FormGroup>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </Col>

                    <Col md={6}>
                        <Row>
                            <Col md={6} className='mt-3'>
                                <label><h6><b>Start Date : </b></h6></label>
                                <div className="position-relative picker-date-width">
                                    <DatePicker
                                        selected={newFormData.startDate ? new Date(newFormData.startDate) : null}
                                        onChange={(date) => {
                                            if (date) {
                                                const year = date.getFullYear();
                                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                                const day = String(date.getDate()).padStart(2, '0');
                                                const dateString = `${year}-${month}-${day}`;
                                                
                                                setNewFormData(prevState => ({ 
                                                    ...prevState, 
                                                    startDate: dateString 
                                                }));
                                            } else {
                                                setNewFormData(prevState => ({ 
                                                    ...prevState, 
                                                    startDate: null 
                                                }));
                                            }
                                        }}
                                        placeholderText="Select"
                                        className="form-control"
                                        id="startDatePicker"
                                        name="startDate"
                                        dateFormat="MM/dd/yyyy"
                                    />
                                    <div className="calendar-icon-wrapper">
                                        <FaCalendarAlt className="calendar-icon" />
                                    </div>
                                </div>
                            </Col>

                            <Col md={6} className='mt-3'>
                                <label><h6><b>Due Date : </b></h6></label>
                                <div className="position-relative picker-date-width" >
                                    <DatePicker
                                        selected={newFormData.dueDate ? new Date(newFormData.dueDate + 'T00:00:00') : null}
                                        onChange={(date) => {
                                            if (date) {
                                                const year = date.getFullYear();
                                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                                const day = String(date.getDate()).padStart(2, '0');
                                                const dateString = `${year}-${month}-${day}`;
                                                
                                                setNewFormData(prevState => ({ 
                                                    ...prevState, 
                                                    dueDate: dateString 
                                                }));
                                            } else {
                                                setNewFormData(prevState => ({ 
                                                    ...prevState, 
                                                    dueDate: null 
                                                }));
                                            }
                                        }}
                                        placeholderText="Select"
                                        className="form-control"
                                        id="dueDatePicker"
                                        name="dueDate"
                                        dateFormat="MM/dd/yyyy"
                                        filterDate={(date) => {
                                            if (newFormData.startDate) {
                                                const startDate = new Date(newFormData.startDate + 'T00:00:00');
                                                return date >= startDate;
                                            }
                                            if (props.projectDetailsForEdit && props.projectDetailsForEdit.startDate) {
                                                const startDate = new Date(props.projectDetailsForEdit.startDate + 'T00:00:00');
                                                return date >= startDate;
                                            }
                                            return true;
                                        }}
                                    />
                                    <div className="calendar-icon-wrapper">
                                        <FaCalendarAlt className="calendar-icon" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col md={12} className='mt-3'>
                        <label><h6><b>Note : </b></h6></label>
                        <ReactQuill
                            theme="snow"
                            modules={Editor.modules}
                            formats={Editor.formats}
                            value={text}
                            onChange={setText}
                            bounds={'.quill-prod'}
                            placeholder='Add Your Comments Here'
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={12} className='mt-4 mb-2 d-flex justify-content-center'>
                        <Button
                            className="btn-background-color"
                            onClick={handleSubmitEditInfo}
                            disabled={!hasFormChanged() || loading}
                        >
                            {loading ? 'Updating...' : 'Update'}
                        </Button>
                    </Col>
                </Row>
            </Col>

            <CustomModal
                header={'Duplicate Project Warning'}
                isOpen={showConfirmationPopup}
                toggle={() => setShowConfirmationPopup(false)}
                size={"md"}
                className='curve-popup'
            >
                <div className="p-3">
                    <p className="mb-3">
                    One or more projects with the same Account, Store, Brand, and Workflow combination already exist:
                    </p>
                    
                    {duplicateProjects && duplicateProjects.length > 0 && (
                        <div className="mb-3">
                            <strong>Existing Projects:</strong>
                            <ul className="mt-2">
                                {duplicateProjects.map((proj, index) => (
                                    <li key={index} className="mb-1">
                                        Project ID: {proj.projectId} | Name: {proj.projectName}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    
                    <p className="mb-4">
                        Are you sure you want to update this project? 
                    </p>
                    
                    <div className='mb-2 d-flex justify-content-end mr-2'>
                        <Button 
                            className="me-2 no-btn-background-color" 
                            onClick={handleCancelDuplicate}
                        >
                            Cancel
                        </Button> &nbsp;
                        <Button 
                            // color="primary" 
                            className='btn-background-color'
                            onClick={handleConfirmDuplicate}
                            style={{ marginLeft: "10px" }}
                            disabled={loading}
                        >
                            {loading ? 'Proceeding...' : 'Proceed'}
                        </Button>
                    </div>
                </div>
            </CustomModal>
            
            <CustomModal
                header={
                    <span>
                        Add ASINs for : <b>{props.projectDetailsForEdit.storeName || ''}</b>
                    </span>
                }
                isOpen={addProductsPopup}
                toggle={() => {
                    setAddProductsPopup(!addProductsPopup);
                }}
                size={"xl"}
                className='my-task-custom-module'
            >
                <NewProjectProductList
                    setAddProductsPopup={setAddProductsPopup}
                    asinList={asinList}
                    setAsinList={setAsinList}
                    productList={productList}
                />
            </CustomModal>
        </>
    );
}

const mapStateToProps = state => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        status: state.loggedUser.status,
    }
}

export default connect(mapStateToProps)(UpdateProjectDetails);